/*
 * Fixed position footer
 * ----------------------------------------------- */
jQuery(window).on("load scroll", function () {
  var $footer = $("footer");
  var $sectionFixed = $(".section-btn-fixed");
  var $pageTop = $(".page-top");

  if ($sectionFixed.length > 0) {
    var sectionPosition =
      $sectionFixed.offset().top + $sectionFixed.outerHeight();
    var pageTopPosition = $pageTop.offset().top + $pageTop.outerHeight();
    var footerPosition = $footer.offset().top;

    if (footerPosition <= sectionPosition) {
      $sectionFixed.removeClass("is-show");
    } else {
      $sectionFixed.addClass("is-show");
    }

    if (footerPosition >= pageTopPosition) {
      $pageTop.removeClass("is-show");
    } else {
      $pageTop.addClass("is-show");
    }
  }
});
